import AdminWebsocket from './AdminWebsocket';

class ComponentInstallClient extends AdminWebsocket {
	connect() {
		return super.connect('/system/install');
	}

	start(componentName) {
		this.sendData('start', { componentName });
	}

	cancelInstall() {
		this.sendData('cancelInstall');
	}

	onStatus(listener) {
		this.onData('status', listener);
	}

	unregisterEventListeners() {
		super.unregisterEventListeners();
		this.onStatus(null);
	}
}

export default ComponentInstallClient;
